import { useState } from "react";
import { useMutation } from "react-query";
import { Card, message, Input, Button } from "antd";
import validator from "validator";
import { useCustomOperate } from "@/hooks";
import { login } from "@/services/user";
import { useUserInfo } from "@/hooks/user";

export default function Login() {
  // 表单数据
  const [formData, setFormData] = useState({ username: '', password: '' });
  // 自定义操作
  const { customLogin } = useCustomOperate();
  // 用户信息
  const { refresh } = useUserInfo();

  // 处理校验
  const handleCheck = () => {
    // 初始化
    let msg = '', flag = false;
    // 解构
    const { username, password } = formData;
    // 校验
    validator.isEmpty(username) ? msg = '请输入用户名'
          : validator.isEmpty(password) ? msg = '请输入密码' : flag = true;
    !flag ? message.info(msg) : '';
    return flag;
  };

  // 处理登录
  const handleLogin = useMutation(async () => {
    if (handleCheck()) {
      // 登录
      const res: any = await login(formData);
      // 处理跳转
      customLogin(res?.token);
      refresh();
    }
  });

  return (
    <div className="h-screen flex justify-center items-center">
      <Card title="欢迎使用后台管理系统" hoverable={true} style={{borderRadius: "8px"}} className="min-w-[400px]">
        <div className="">
          <span className="text-red-500">*</span> 用户名
        </div>
        <Input value={formData.username} placeholder="请输入用户名" onChange={(e) => setFormData(({ ...formData, username: e.target.value }))} className="mt-3"/>
        <div className="mt-5">
          <span className="text-red-500">*</span> 密码
        </div>
        <Input.Password  value={formData.password} placeholder="请输入密码" onChange={(e) => setFormData(({ ...formData, password: e.target.value }))} className="mt-3"/>
        <div className="mt-6 grid grid-cols-2 gap-5">
          <Button type="primary" loading={handleLogin.isLoading} onClick={() => handleLogin.mutate()}>登录</Button>
          <Button onClick={() => setFormData({ username: '', password: '' })}>重置</Button>
        </div>
      </Card>
    </div>
  );
}
